import {autoserializeAs, inheritSerialization} from "dcerialize";
import type {Existing, NumberedIdentifiableModel} from "../base/IdentifiableModel";
import type {ModificationTrackedModel} from "../base/ModificationTrackedModel";
import {ModificationDetails} from "../ModificationDetails";

export type ArticleGroupNumber = number;

// noinspection TypeScriptRedundantGenericType
export class IdOnlyArticleGroup implements NumberedIdentifiableModel<ArticleGroupNumber> {
  @autoserializeAs(() => Number)
  public number: ArticleGroupNumber;

  public get id(): ArticleGroupNumber {
    return this.number;
  }

  public set id(value: ArticleGroupNumber) {
    this.number = value;
  }

  public static existing(number: ArticleGroupNumber): Existing<IdOnlyArticleGroup> {
    return new IdOnlyArticleGroup(number);
  }

  public constructor(number: ArticleGroupNumber) {
    this.number = number;
  }
}

@inheritSerialization(() => IdOnlyArticleGroup)
export class ArticleGroup extends IdOnlyArticleGroup implements ModificationTrackedModel {
  @autoserializeAs(() => ModificationDetails)
  public readonly modificationDetails?: ModificationDetails;
}
